<template>
	<div class="leaderboard" :class="{ text }">
		<LeaderboardFirst
			v-if="first"
			:submission="first"
			:wall="wall"
			@select="select"
		/>
		<div class="leaderboard__table">
			<!-- CSS subgrid or display: contents; support would be lovely -->
			<template v-for="item in rest">
				<!-- Leaderboard position -->
				<div
					:key="`${item.id}_pos`"
					:class="rowClasses(item, 'pos')"
					@click="onRowClick(item)"
					@mousedown="onRowDown(item)"
					@mouseenter="onRowEnter(item)"
					@mouseleave="onRowLeave"
				>
					{{ item.position }}
				</div>
				<!-- Thumbnail -->
				<div
					:key="`${item.id}_thumbnail`"
					:class="rowClasses(item, 'thumbnail')"
					@click="onRowClick(item)"
					@mousedown="onRowDown(item)"
					@mouseenter="onRowEnter(item)"
					@mouseleave="onRowLeave"
				>
					<div
						v-if="item.thumbnail"
						class="row--thumbnail__img"
						:style="item.thumbnail"
					></div>
				</div>
				<!-- Title -->
				<div
					:key="`${item.id}_title`"
					:class="rowClasses(item, 'title')"
					@click="onRowClick(item)"
					@mousedown="onRowDown(item)"
					@mouseenter="onRowEnter(item)"
					@mouseleave="onRowLeave"
				>
					<div :class="{ text }">{{ item.title }}</div>
				</div>
				<!-- Likes -->
				<div
					:key="`${item.id}_likes`"
					:class="rowClasses(item, 'likes')"
					@click="onRowClick(item)"
					@mousedown="onRowDown(item)"
					@mouseenter="onRowEnter(item)"
					@mouseleave="onRowLeave"
				>
					{{ item.likes | number }}
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import { enums } from 'protoswipe-shared'
import LeaderboardFirst from '@/components/main/LeaderboardFirst'

export default {
	name: 'Leaderboard',
	props: {
		results: Array,
		wall: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			hovered: null
		}
	},
	computed: {
		empty() {
			return this.results.length === 0
		},
		first() {
			if (this.empty) return null
			return this.formatResult(this.results[0])
		},
		text() {
			if (this.empty) return null
			return this.first.campaign.type === enums.CampaignType.text
		},
		rest() {
			return this.results.slice(1).map(this.formatResult)
		}
	},
	methods: {
		getThumbnail({ drawing, image }) {
			if (!drawing && !image) return null
			const src = drawing || process.env.VUE_APP_API_BASE + image.url
			return { backgroundImage: `url(${src})` }
		},
		formatResult(result, index) {
			const position = index + 2
			const thumbnail = this.getThumbnail(result)
			const bind = {
				key: result.id,
				class: { hover: result.id === this.hovered }
			}
			return { ...result, position, thumbnail, bind }
		},
		select(id) {
			this.$emit('view', id)
		},
		emitUpdated() {
			this.$emit('updated')
		},
		// Row bindings
		rowClasses(item, column) {
			const hover = item.id === this.hovered
			return ['row', `row--${column}`, { hover }]
		},
		onRowClick({ id }) {
			if (!this.wall) this.select(id)
		},
		onRowDown({ id }) {
			if (this.wall) this.select(id)
		},
		onRowEnter({ id }) {
			if (this.wall) this.hovered = id
		},
		onRowLeave() {
			this.hovered = null
		}
	},
	watch: {
		results() {
			this.$nextTick(this.emitUpdated)
		}
	},
	mounted() {
		this.emitUpdated()
	},
	components: {
		LeaderboardFirst
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';

$gap: 0.5rem;
$br: 0.25rem;

.leaderboard {
	margin: 0 auto;
	width: 100%;
	max-width: 600px;

	&__table {
		display: grid;
		grid-template-columns: auto auto 1fr auto;
		grid-template-rows: auto;
		grid-row-gap: $gap;
	}
}

.row {
	@extend %flex-row;
	min-height: 3.625rem;
	padding: 0.5rem 0;
	background-color: $white;
	cursor: pointer;

	&.hover {
		color: $white;
		background-color: $blue-48;
	}

	&--pos {
		border-radius: $br 0 0 $br;
		padding-left: 1rem;
		padding-right: 1rem;
		justify-content: center;
		font-weight: bold;
	}

	&--thumbnail {
		&__img {
			@include thumbnail(2.5rem);
			margin-right: 0.75rem;
		}
	}

	&--title {
		padding-right: 0.75rem;
		overflow: hidden;
		.text {
			@extend %nowrap;
		}
	}

	&--likes {
		border-radius: 0 $br $br 0;
		justify-content: flex-end;
		padding-right: 0.75rem;
	}
}
</style>
